import React from 'react';

const STEPS = [
  { n: '01', t: 'Profile your organization', d: 'Industry, region, technology, security program and risk context, recorded by your representative when your organization is created.' },
  { n: '02', t: 'Feeds are collected and enriched', d: 'Public feeds are polled continuously. Coverage of the same event is merged, indicators are extracted and CVEs are checked against CISA KEV.' },
  { n: '03', t: 'Briefs are matched to you', d: 'Each story is scored against your profile. Matches reach your Inbox; the rest stay out of the way.' },
  { n: '04', t: 'Detection ships', d: 'Generated YARA, Sigma and SIEM queries export in one click or go out by webhook.' },
];

export default function WelcomeHowItWorks() {
  return (
    <section id="how-it-works" className="wl-section" aria-labelledby="wl-how-title">
      <div className="wl-container">
        <div className="wl-head">
          <div className="wl-eyebrow">How it works</div>
          <h2 id="wl-how-title" className="wl-h2">
            From raw intelligence to shipped detection, <em>in four steps.</em>
          </h2>
        </div>

        <ol className="wl-steps">
          {STEPS.map((s) => (
            <li key={s.n}>
              <div className="wl-num">Step {s.n}</div>
              <h3 className="wl-h3">{s.t}</h3>
              <p className="wl-body">{s.d}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
